import { render } from "./Expression.vue?vue&type=template&id=096f8908"
import script from "./Expression.vue?vue&type=script&setup=true&lang=js"
export * from "./Expression.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Commencer/Expression.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "096f8908"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('096f8908', __exports__)) {
    api.reload('096f8908', __exports__)
  }
  
  module.hot.accept("./Expression.vue?vue&type=template&id=096f8908", () => {
    api.rerender('096f8908', render)
  })

}


export default __exports__